import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-footer-atricon',
  standalone: false,
  templateUrl: './footer-atricon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer-atricon.component.css'
})
export class FooterAtriconComponent {

}
